module.exports = import("https://unpkg.com/threejs-toys@0.0.8/build/threejs-toys.module.cdn.min.js");;